<template>
	<table class="performanceTable">
		<thead>
			<tr>
				<th>Staff Name</th>
				<th>ORDER NO.</th>
				<th>ITEM NO.</th>
			</tr>
		</thead>
		<tbody>
			
		</tbody>
	</table>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "",
	components: {}
});
</script>

<style lang="scss" scoped>
.performanceTable {
	margin: 20px auto;

	th,
	td {
		border: 1px solid $border-color;
		text-align: center;
		padding: 7px 0;
		font-size: 14px;
	}

	th {
		text-transform: uppercase;
		background-color: lighten($color7, 10%);
		font-weight: 500;
		width: 140px;
	}

	td {
		background-color: $table-light-bg;
	}
}
</style>